import dayjs from "dayjs";
import { Gauge } from "lucide-react";
import { AED } from "../../lib/api";

export const SalikSection = ({ data }) => (
  <div className="bg-white border border-[#e2ebe4] rounded-lg p-5" data-testid="salik-section">
    <h3 className="heading-upper text-sm tracking-widest text-[#144733] mb-4 flex items-center gap-2"><Gauge className="w-4 h-4 text-[#009900]" /> Toll crossings (Salik / Darb)</h3>
    {data.salik.length === 0 ? (
      <p className="text-sm text-[#57685e]">No toll crossings recorded so far.</p>
    ) : (
      <>
        <table className="w-full text-sm" data-testid="salik-table">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-wide text-[#8a978f] border-b border-[#e2ebe4]">
              <th className="py-2">Gate</th><th>Date & time</th><th className="text-right">AED</th>
            </tr>
          </thead>
          <tbody>
            {data.salik.map((s) => (
              <tr key={s.id} className="border-b border-[#f1f3f1]">
                <td className="py-2 font-medium text-[#0F1E17]">{s.gate}</td>
                <td className="text-[#57685e]">{dayjs(s.datetime).format("DD MMM, HH:mm")}</td>
                <td className="text-right font-semibold">{s.amount.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mt-3 space-y-1.5 text-sm">
          <div className="flex justify-between"><span className="text-[#57685e]">Toll charges</span><span>{AED(data.toll_total)}</span></div>
          <div className="flex justify-between"><span className="text-[#57685e]">Admin fee (25%)</span><span>{AED(data.toll_admin_fee)}</span></div>
          <div className="flex justify-between font-bold border-t border-[#e2ebe4] pt-2"><span>Total tolls</span><span data-testid="toll-total">{AED(data.toll_grand_total)}</span></div>
        </div>
      </>
    )}
  </div>
);
